import { importProvidersFrom } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { appRoutes } from './app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { MatDialogModule } from '@angular/material/dialog';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatNativeDateModule } from '@angular/material/core';
import { provideNavigation } from './core/navigation/navigation.provider';
import { vexConfigs } from '@vex/config/vex-configs';
import { provideVex } from '@vex/vex.provider';
import { provideQuillConfig } from 'ngx-quill';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

export const vexThemeProviders = [
    importProvidersFrom(BrowserModule, MatDialogModule, MatBottomSheetModule, MatNativeDateModule),
    provideRouter(
        appRoutes,
        withInMemoryScrolling({
            anchorScrolling: 'enabled',
            scrollPositionRestoration: 'enabled',
        }),
    ),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    provideVex({
        config: vexConfigs.apollo,
        availableThemes: [],
    }),
    provideNavigation(),
    provideQuillConfig({
        modules: {
            toolbar: [
                // Text formatting row
                [{ size: ['small', false, 'large', 'huge'] }],
                [{ header: [1, 2, 3, 4, 5, 6, false] }],

                // Style formatting row
                ['bold', 'italic', 'underline', 'strike'],
                [{ color: [] }, { background: [] }],
                [{ script: 'sub' }, { script: 'super' }],

                // Paragraph formatting row
                [{ align: [] }],
                [{ list: 'ordered' }, { list: 'bullet' }],
                [{ indent: '-1' }, { indent: '+1' }],
                ['blockquote', 'link'],

                // Utilities
                ['clean'],
            ],
        },
    }),
    provideAnimationsAsync(),
];
